import React, { ReactElement } from 'react'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import { Variant } from '@material-ui/core/styles/createTypography'
import { printConfig } from '../../config'

const useStyles = makeStyles(theme => ({
  text: {
    margin: (p: StyleProps) => theme.spacing(p.marginTop || 'auto', 0, p.marginBottom || 'auto'),
    '@media print': {
      fontFamily: printConfig.defaults.fontName,
      fontWeight: theme.typography.fontWeightBold,
      fontSize: (p: StyleProps) => p.printFontSize,
      borderBottom: (p: StyleProps) =>
        p.printBottomBorder && printConfig.mainHeading.showBottomBorder ? '2px solid' : ''
    }
  }
}))

export interface IPrintProps {
  printFontSize?: number
  printBottomBorder?: boolean
}

export interface IMarginProps {
  marginTop?: number
  marginBottom?: number
}

export interface ITypographyProps {
  title: string
  variant?: Variant
}

export type TitleProps = IMarginProps & IPrintProps & ITypographyProps
export type StyleProps = IMarginProps & IPrintProps

function Title({
  title,
  printFontSize,
  printBottomBorder,
  marginTop,
  marginBottom,
  variant = 'h4'
}: TitleProps): ReactElement {
  const classes = useStyles({ marginTop, marginBottom, printFontSize, printBottomBorder })
  return (
    <Typography variant={variant} className={classes.text}>
      {title}
    </Typography>
  )
}

export default Title
